import { AsyncResource } from "./AsyncResource";
import { DeliveryInstructions } from "./DeliveryInstructions";
import { State } from "./State";

export type CountryWithoutStates = {
  id: string;
  name: string;
};

// Plugins augment this interface with address attributes they own.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface AddressPluginFields {}

export enum Warehouse {
  Champion = "champion",
  Vernon = "vernon",
  ShipStation = "shipstation",
  ClarkAndRiggsSAB = "clark_and_riggs_sab",
  ClarkAndRiggsSRS = "clark_and_riggs_srs",
  ClarkAndRiggsCouponsAndRebates = "clark_and_riggs_coupons_and_rebates",
}

export type WarehouseID =
  | Warehouse.Champion
  | Warehouse.Vernon
  | Warehouse.ShipStation
  | Warehouse.ClarkAndRiggsSAB
  | Warehouse.ClarkAndRiggsSRS
  | Warehouse.ClarkAndRiggsCouponsAndRebates;

type AddressBase = {
  type: "warehouse" | "address";
  id: string;
  isReadOnly: boolean;
  city: string;
  defaultAttn?: string;
  externalId?: string;
  name: string;
  phoneNumber: string;
  region: string;
  streetAddress1: string;
  streetAddress2?: string;
  territoryId: number;
  territoryName: string;
  warehouse?: WarehouseID;
  zip: string;
  country: CountryWithoutStates;
  userId: string;
  userName: string;
  organization: AsyncResource<"organization">;
  state?: State;
  shippingNotificationEmail: string | null;
  deliveryInstructions: null | DeliveryInstructions;
  distributor: AsyncResource<"distributor">;
  distributorName: string | null;
};

export type Address = AddressBase & Partial<AddressPluginFields>;
